// Variant updates replace the trigger; delegate opening while keeping native modal behavior.
if(!window.artGuideTriggerBound){
  window.artGuideTriggerBound=true;
  document.addEventListener('click',event=>{
    const trigger=event.target.closest?.('.meson-size-guide-trigger[data-art-guide-open]');
    if(!trigger)return;
    const modal=document.getElementById(trigger.getAttribute('aria-controls'));
    if(typeof modal?.show!=='function')return;
    event.preventDefault();event.stopImmediatePropagation();modal.show(trigger);
  },true);
}
if(!customElements.get('art-random-number'))customElements.define('art-random-number',class extends HTMLElement{
  connectedCallback(){
    if(this.generated||this.dataset.random!=='true')return;
    this.generated=true;
    const a=Number(this.dataset.min),b=Number(this.dataset.max);
    const low=Math.max(0,Math.ceil(Math.min(Number.isFinite(a)?a:0,Number.isFinite(b)?b:0)));
    const high=Math.max(low,Math.floor(Math.max(Number.isFinite(a)?a:0,Number.isFinite(b)?b:0)));
    this.textContent=String(low+Math.floor(Math.random()*(high-low+1)));
  }
});
if (!customElements.get('art-info-controls')) customElements.define('art-info-controls', class extends HTMLElement {
  connectedCallback() {
    this.abort?.abort(); this.abort = new AbortController();
    const options = {signal:this.abort.signal};
    this.info = this.closest('product-info');
    this.info.toggleAttribute('data-motion-reduced',Boolean(window.theme?.config?.motionReduced));
    this.confirmed = this.info.dataset.artSizeConfirmed === 'true' || new URL(location.href).searchParams.has('variant');
    this.seen = new WeakSet();
    this.initializeSizes();
    this.observer = new MutationObserver(()=>this.initializeSizes());
    this.observer.observe(this.info,{childList:true,subtree:true});
    this.info.addEventListener('change',event=>{
      const size=this.info.querySelector('variant-picker[id] [data-art-size]');
      if(event.target.matches('[data-art-size]') && event.target.value) {
        this.confirmed=true;this.info.dataset.artSizeConfirmed='true';
        event.target.removeAttribute('aria-invalid');
        event.target.removeAttribute('aria-describedby');
        this.info.querySelector('[data-art-size-error]')?.remove();
      } else if(event.target.matches('.art-frame-options input') && size && !this.confirmed) {
        size.value=size.querySelector('option[selected]:not([data-art-placeholder])')?.value||size.options[1]?.value||'';
        queueMicrotask(()=>{if(!this.confirmed)size.value='';});
      }
    },{...options,capture:true});
    const guard=event=>{
      const target=event.target;
      const button=target.closest?.('button[name="add"],.shopify-payment-button,.shopify-payment-button__more-options');
      if(event.type==='click'&&!button)return;
      const form=event.type==='submit'?target:(button?.form||button?.closest('form'));
      if(!form || form.getAttribute('id')!==this.info.getAttribute('form'))return;
      const size=this.info.querySelector('variant-picker[id] [data-art-size]');
      if(!size || this.confirmed)return;
      event.preventDefault();event.stopImmediatePropagation();
      size.setAttribute('aria-invalid','true');
      if(!this.info.querySelector('[data-art-size-error]')){
        const error=document.createElement('p');error.className='art-size-error';error.dataset.artSizeError='';error.id=`${size.id}-error`;error.setAttribute('role','alert');error.textContent=this.dataset.required;
        size.closest('.variant-input-wrapper').append(error);size.setAttribute('aria-describedby',error.id);
      }
      size.focus({preventScroll:true});size.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    };
    document.addEventListener('click',guard,{...options,capture:true});
    document.addEventListener('submit',guard,{...options,capture:true});
    this.info.querySelectorAll('[data-art-save]').forEach(button=>{
      const key='artwork-saved-products';
      const read=()=>{try{const saved=JSON.parse(localStorage.getItem(key)||'[]');return Array.isArray(saved)?saved:[];}catch{return [];}};
      button.setAttribute('aria-pressed',String(read().some(item=>item.id===button.dataset.product)));
      button.addEventListener('click',()=>{
        const saved=read(),exists=saved.some(item=>item.id===button.dataset.product);
        const next=exists?saved.filter(item=>item.id!==button.dataset.product):[...saved,{id:button.dataset.product,url:this.info.dataset.productUrl,title:this.info.querySelector('h1')?.textContent.trim()}];
        try{localStorage.setItem(key,JSON.stringify(next));button.setAttribute('aria-pressed',String(!exists));window.dispatchEvent(new CustomEvent('artwork:saved',{detail:{products:next}}));}catch{button.setAttribute('aria-pressed',String(!exists));}
      },options);
    });
  }
  initializeSizes(){
    this.info.querySelectorAll('[data-art-size]').forEach(size=>{
      if(this.seen.has(size))return;this.seen.add(size);
      if(!this.confirmed)size.value='';
    });
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});
if(!customElements.get('art-deadline'))customElements.define('art-deadline',class extends HTMLElement{
  connectedCallback(){
    const end=Date.parse(this.dataset.end);if(!Number.isFinite(end))return;
    const tick=()=>{const seconds=Math.max(0,Math.floor((end-Date.now())/1000));this.hidden=seconds===0;if(!seconds){clearInterval(this.timer);return;}const hours=Math.floor(seconds/3600),minutes=Math.floor(seconds%3600/60);this.textContent=`${String(hours).padStart(2,'0')}H : ${String(minutes).padStart(2,'0')}M : ${String(seconds%60).padStart(2,'0')}S`;};
    tick();if(end>Date.now())this.timer=setInterval(tick,1000);
  }
  disconnectedCallback(){clearInterval(this.timer);}
});
if(!customElements.get('art-delivery-date'))customElements.define('art-delivery-date',class extends HTMLElement{
  connectedCallback(){const format=days=>{const date=new Date();date.setDate(date.getDate()+days);return new Intl.DateTimeFormat(document.documentElement.lang||'en',{month:'short',day:'numeric'}).format(date);};const min=Math.max(0,Number(this.dataset.min)||0),max=Math.max(min,Number(this.dataset.max)||0);this.textContent=`${format(min)}–${format(max)}`;}
});
